import * as http from 'axios'

export const saveCartao = (payload) => http.post('/cartao', payload)
export const getCartao = (id) => http.get(`/cartao/id/${id}`)
export const getSaude = (id) => http.get(`/saudes/${id}`)



// WEBPACK FOOTER //
// ./src/store/cartaoSin/services.js